<template>
  <div class="expandable-vuln-section">
    <div class="headerItem" @click="toggleExpanded">
      <div class="arrow-container" :class="{ expanded: isExpanded }">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.7364 9.3636C17.3849 9.01213 16.8151 9.01213 16.4636 9.36361L12 13.8272L7.53639 9.3636C7.18492 9.01213 6.61507 9.01213 6.2636 9.36361C5.91213 9.71508 5.91213 10.2849 6.2636 10.6364L11.3636 15.7364C11.7151 16.0879 12.285 16.0879 12.6364 15.7364L17.7364 10.6364C18.0879 10.2849 18.0879 9.71507 17.7364 9.3636Z"
            fill="#949DB8"
          />
        </svg>
      </div>

      <div class="headerTitle">
        <div>{{ title }}</div>
      </div>

      <div class="methodLabel">{{ testingMethodText }}</div>

      <div class="lineItem"></div>
    </div>

    <div v-if="isExpanded" class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableVulnSection',
  props: {
    title: {
      type: String,
      required: true,
    },
    initiallyExpanded: {
      type: Boolean,
      default: false,
    },
    testingMethodText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  beforeMount() {
    this.isExpanded = this.initiallyExpanded;
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
      this.$emit('toggle', this.isExpanded);
    },
    expand() {
      this.isExpanded = true;
      this.$emit('toggle', this.isExpanded);
    },
    collapse() {
      this.isExpanded = false;
      this.$emit('toggle', this.isExpanded);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/fonts.scss';
@import '@/assets/css/variables.scss';

.content {
  padding-left: 16px;
}

.headerItem {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
}

.headerTitle {
  @include Aspekta-font(600, 18px, 26px, #242424);
  letter-spacing: 0.03em;
}

.lineItem {
  flex: 1 0 auto;
  height: 1px;
  background: #e3e6ed;
}

.methodLabel {
  @include Aspekta-font(500, 12px, 1.5, #3180f6);
  letter-spacing: 0.05em;
  padding: 3px 12px;
  background: #ebf2fd;
  border-radius: 100px;
  display: flex;
  align-items: center;
}

.arrow-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;

  &.expanded {
    transform: rotate(180deg);
  }
}
</style>
